export const styles = () => ({
  container: {
    padding: 10,
  },
  paper: {
    padding: 20,
    width: '100%',
  },
});
